// Shown wherever the database reader is not live yet: explains, links the ask, offers Try again.
import { DB_UNAVAILABLE } from '../../../shared/types';
import { GCard, GH2, GPill } from './atoms';

export function isDbUnavailable(error: string | null | undefined): boolean { return !!error && error.startsWith(DB_UNAVAILABLE); }

export function DbPending({ error, onRetry }: { error: string; onRetry: () => void }) {
  return (
    <GCard padding="22px 24px" style={{ maxWidth: 720 }}>
      <GH2 size={18}>Database access pending</GH2>
      <div style={{ fontFamily: 'var(--ff-mono)', fontSize: 13.5, color: 'var(--fg-2)', marginTop: 10, lineHeight: 1.6 }}>
        This screen reads the Projector database through the read-only role the server team agreed to on 2026-10-12.
        Until that role, its secret and the security-group rule are live, there is nothing to show here.
      </div>
      <div style={{ fontFamily: 'var(--ff-code)', fontSize: 12, color: 'var(--fg-4)', marginTop: 10, overflowWrap: 'anywhere' }}>{error.replace(DB_UNAVAILABLE, '').trim()}</div>
      <div style={{ fontFamily: 'var(--ff-code)', fontSize: 12, color: 'var(--fg-4)', marginTop: 6 }}>ProjectorDashboard/docs/server-requests/dashboard-readonly-db-role.md</div>
      <div style={{ marginTop: 16 }}><GPill onClick={onRetry}>Try again</GPill></div>
    </GCard>
  );
}
